import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";

export default function NotFound() {
    const { isDarkMode } = useTheme();
    

    return (
        <div className={`min-h-screen flex flex-col items-center justify-center p-4 transition-colors duration-500 ${isDarkMode ? "bg-[#0f172a] text-white" : "bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 text-gray-800"}`}>

            {/* Glass Card */}
            <div className={`relative p-8 md:p-12 rounded-3xl text-center max-w-lg w-full backdrop-blur-2xl border shadow-2xl ${isDarkMode ? "bg-white/5 border-white/10 shadow-black/50" : "bg-white/60 border-white/40 shadow-xl"}`}>

                {/* Animated 404 Graphic */}
                <div className="text-9xl font-extrabold mb-2 tracking-tighter bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-600 animate-pulse">
                    404
                </div>

                <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full mb-6"></div>

                <h2 className="text-3xl font-bold mb-4">Page Not Found</h2>

                <p className={`text-lg mb-8 leading-relaxed ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
                    Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
                </p>

                <Link
                    to="/"
                    className="inline-flex items-center justify-center px-8 py-3 rounded-xl font-bold text-white bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 transition-all transform hover:scale-105 shadow-lg hover:shadow-purple-500/30 active:scale-95"
                >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>
                    Go Home
                </Link>

            </div>

            <div className={`mt-8 text-sm ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}>
                ChatIQ Web Messenger
            </div>

        </div>
    );
}
